import React from 'react';
import { Flex, Box, Heading, Text, useColorModeValue } from '@chakra-ui/react';
import { StepperSidebar } from 'src/features/Signup/components/organisms/StepperSidebar';

type PageContainerProps = {
  title: string;
  subtitle: string;
  children: React.ReactNode;
  currentStep: number;
  onNext?: () => void;
  onBack?: () => void;
  isBackDisabled: boolean;
  isNextDisabled: boolean;
  isFormValid?: boolean;
};

export const PageContainer: React.FC<PageContainerProps> = ({
  title,
  subtitle,
  children,
  currentStep,
  onNext,
  onBack,
  isBackDisabled,
  isNextDisabled,
  isFormValid,
}) => {
  const pageBg = useColorModeValue(
    'background.light.highest',
    'background.dark.lowest',
  );

  return (
    <Box minH="100vh" bg={pageBg} px={0} py={0}>
      <Box
        mx="auto"
        pt={{ base: 6, md: '70px' }}
        pb={0}
        px={{ base: 4, md: 24, lg: 32 }}>
        <Heading
          as="h1"
          size="xl"
          mb={4}
          color="text.title"
          fontWeight={700}
          fontFamily="marketingPage">
          {title}
        </Heading>
        <Text color="text.muted" mb={8} fontSize="16px">
          {subtitle}
        </Text>
        <Flex
          gap={{ base: 8, md: 14 }}
          align="flex-start"
          justify={{ base: 'center', md: 'space-between' }}
          direction={{ base: 'column', md: 'row' }}>
          <Box flex={1} w="70%">
            {children}
          </Box>
          <Box
            w={{ base: '100%', md: '427px' }}
            mt={{ base: 8, md: 0 }}
            bg="surface.card"
            borderRadius={{ base: '24px', md: '32px' }}
            borderColor="border.box"
            p={0}
            position={{ base: 'static', md: 'sticky' }}
            top={{ base: 'auto', md: '24px' }}
            alignSelf="flex-start">
            <StepperSidebar
              currentStep={currentStep}
              onNext={onNext}
              onBack={onBack}
              isBackDisabled={isBackDisabled}
              isNextDisabled={isNextDisabled}
              isFormValid={isFormValid}
            />
          </Box>
        </Flex>
      </Box>
    </Box>
  );
};
